// extracted by mini-css-extract-plugin
export default {"form":"dm-z","error":"em-z","disabled":"fm-z"};